<template>
  <div class="flex flex-col px-8 justify-between grow">
    <div>
      <div v-if="card.TopLabel" class="relative">
        <AppLabel
          color="few-left"
          class="absolute mt-[-16px] ml-0 md:ml-16 whitespace-nowrap"
          :text="card.TopLabel"
        />
      </div>
      <div
        v-if="card.Title"
        class="flex flex-row justify-center"
        :class="{ 'pt-28': !!card.TopLabel }"
      >
        <p class="heading-xxs">{{ card.Title }}</p>
      </div>
      <div
        v-if="card.MainPriceLabel"
        class="flex flex-row justify-center py-15"
      >
        <BoxedText
          element="p"
          box-color-class="bg-surface-action-1"
          text-color-class="text-text-on-highlight"
          text-class="heading-sm"
          >{{ card.MainPriceLabel }}
        </BoxedText>
      </div>

      <div v-if="card.SubText" class="flex flex-row justify-center text-center">
        <p v-html="markup_markdownLikeTextToHtmlString(card.SubText)"></p>
      </div>

      <div v-if="card.MainAllowanceLabel" class="h-56 my-8">
        <SeasonalDealsSimCardShape
          class="flex flex-row justify-end"
          inner-classes="mr-[-20px] md:mr-0"
        >
          <p
            v-if="card.SubAllowanceLabel"
            class="text-text-on-highlight"
            v-html="markup_markdownLikeTextToHtmlString(card.SubAllowanceLabel)"
          ></p>
          <p class="text-text-on-highlight body-link-md md:text-22-24">
            {{ card.MainAllowanceLabel }}
          </p>
        </SeasonalDealsSimCardShape>
      </div>
    </div>

    <div class="flex flex-col">
      <div
        v-if="card.MainProductImage"
        class="relative flex flex-row justify-center"
      >
        <NuxtImg
          :src="card.MainProductImage"
          provider="cloudfront"
          class="w-114 md:w-150 mr-0 md:mr-16 object-contain object-bottom"
          format="webp"
          quality="75"
          alt=""
        />

        <NuxtImg
          v-if="card.FreeAccessoryProductImage"
          :src="card.FreeAccessoryProductImage"
          alt=""
          class="absolute right-[20%] bottom-[-0rem] w-65 h-auto"
          format="webp"
          quality="75"
          provider="cloudfront"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { markup_markdownLikeTextToHtmlString } from '~/utils/markup/allTextTransformations';
import type { SeasonDealMarkupCard } from '~/models/seasonaldeals/SeasonalDealMarkupCard.model';

interface Props {
  card: SeasonDealMarkupCard;
}

defineProps<Props>();
</script>
